import Vue from 'vue';
import VueResource from 'vue-resource';
import salvarArquivo from '~js/salvar-arquivo';

Vue.use(VueResource);


export default {
  gerarIRPF: anoBase => {
    return Vue.http.get(`/api/pessoas/gerarIRPF/${anoBase}`)
      .then(resposta => resposta.data);
  },
  buscarAssinaturas: () => {
    return Vue.http.get(`/api/pessoas/buscarAssinaturas/`)
      .then(resposta => resposta.data);
  },
  buscarAssinatura: (id) => {
    return Vue.http.get(`/api/pessoas/buscarAssinatura/${id}`)
      .then(resposta => resposta.data);
  },
  downloadArquivoAssinatura: (idDocumentoAssinaturaAssinante, nome) => {
    return Vue.http.get(`/api/pessoas/downloadArquivoAssinatura/${idDocumentoAssinaturaAssinante}`, {
      responseType: 'blob'
    })
      .then(response => {
        return salvarArquivo(response, nome);
      });
  },
  visualizarArquivoAssinatura: idDocumentoAssinaturaAssinante => {
    return Vue.http.get( `/api/pessoas/downloadarquivoassinatura/${idDocumentoAssinaturaAssinante}`, {
      responseType: 'blob'
    })
      .then(response => response.blob());
  },
  assinarDocumento: idDocumentoAssinaturaAssinante => {
    return Vue.http.get( `/api/pessoas/assinarDocumento/${idDocumentoAssinaturaAssinante}`, {
      responseType: 'blob'
    })
      .then(response => response.blob());
  },
}



// WEBPACK FOOTER //
// ./FrontEnd/modulos/pessoa-fisica/servico.js